module.exports = __webpack_public_path__ + "img/adrian-TvN54bnuQg8-unsplash.8c49c896.jpg";